var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMonitorEngineContext, useMonitorNavigation } from "@nibfe/mcp-monitor-sdk";
import { useRequest } from "./useRequest";
import { API_PATH, getRiskRequest } from "./useRequest";
import { useCallback, useState } from "@max/max";
import { convertLinkToAppMiddleOpenLink } from "@/utils/common";
import { getPlatformType, isDianpingAppOrWebview, isMeituanAppOrWebview, isWeixinMiniProgramOrWeixinWebview, PlatformType } from "@nibfe/mkt-env-api";
export function useRecommendPoi(options) {
    const ctx = useMonitorEngineContext();
    const [recommendPoiData, setRecommendPoiData] = useState();
    const [poiList, setPoiList] = useState([]);
    const { requestStatus, request } = useRequest(API_PATH.RECOMMEND_POI);
    const { monitorNavigateTo } = useMonitorNavigation();
    function loadRecommendPoi() {
        var _a, _b, _c, _d, _e, _f, _g;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { uuid, lat, lng, cityInfo } = ((_a = ctx._runtimeInfo) === null || _a === void 0 ? void 0 : _a.commonParams) || {};
                const transformLat = Number.isNaN(Number(lat)) || Number(lat) === 0 ? -1.0 : Number(lat);
                const transformLng = Number.isNaN(Number(lng)) || Number(lng) === 0 ? -1.0 : Number(lng);
                const { cityId, locCityId } = cityInfo || {};
                // 获取风险参数
                const riskParams = yield getRiskRequest(uuid);
                const res = yield request({
                    flowSource: 7,
                    // 固定传7
                    // @ts-expect-error 
                    uuid: uuid || riskParams.uuid || '',
                    lat: transformLat,
                    lng: transformLng,
                    pageNo: 1,
                    // 默认填1
                    pageSize: 3,
                    // 建议3个以内
                    cityId: cityId !== null && cityId !== void 0 ? cityId : 1,
                    // 拿不到传1
                    locateCityId: locCityId !== null && locCityId !== void 0 ? locCityId : 1,
                    // 拿不到传1
                    // 客户端核心参数，从风险参数中获取
                    utm_campaign: riskParams.utmCampaign || '',
                    utm_content: riskParams.utmContent || '',
                    utm_medium: riskParams.utmMedium || 'android',
                    utm_source: riskParams.utmSource || '',
                    utm_term: riskParams.utmTerm || '',
                    version_name: riskParams.versionName || '12.42.200'
                });
                if (res && Array.isArray(res.remainRecPoiInfo)) {
                    setRecommendPoiData(res);
                    setPoiList(res.remainRecPoiInfo);
                    (_c = (_b = ctx._raptorReport).monitorReportBizSuccess) === null || _c === void 0 ? void 0 : _c.call(_b, {
                        apiPath: API_PATH.RECOMMEND_POI
                    });
                    return res;
                }
                else {
                    throw new Error('获取推荐POI数据失败');
                }
            }
            catch (error) {
                (_e = (_d = ctx._raptorReport).monitorReportBizFailed) === null || _e === void 0 ? void 0 : _e.call(_d, {
                    apiPath: API_PATH.RECOMMEND_POI
                });
                (_g = (_f = ctx._raptorReport).monitorReportLog) === null || _g === void 0 ? void 0 : _g.call(_f, error.message, error, {
                    category: 'ajaxError',
                    level: 'error'
                });
                // throw error;
            }
        });
    }
    const browseRecommendedHotelPoi = useCallback(() => {
        var _a, _b;
        const poiId = (_b = (_a = poiList[0]) === null || _a === void 0 ? void 0 : _a.poiId) !== null && _b !== void 0 ? _b : 717819091;
        const envokePoiDetailLink = convertLinkToAppMiddleOpenLink(`imeituan://www.meituan.com/mrn?mrn_biz=hotel&mrn_entry=rn-hotel-poidetail&mrn_component=hotel-poidetail&_page_new=1&_speed_mode=1&id=${poiId}`);
        if (isMeituanAppOrWebview()) {
            return monitorNavigateTo({
                url: `imeituan://www.meituan.com/mrn?mrn_biz=hotel&mrn_entry=rn-hotel-poidetail&mrn_component=hotel-poidetail&_page_new=1&_speed_mode=1&id=${poiId}`
            });
        }
        else if (isDianpingAppOrWebview()) {
            // 点评app
            return monitorNavigateTo({
                url: `dianping://shopinfo?shopuuid=${poiId}`
            });
        }
        else if (isWeixinMiniProgramOrWeixinWebview()) {
            const platformType = getPlatformType();
            switch (platformType) {
                case PlatformType.mtMinaWebview:
                    // 美团小程序
                    return monitorNavigateTo({
                        url: `/hotel/pages/poi/pages/index/index?poiId=${poiId}`,
                        _web: {
                            miniProgramNative: true
                        }
                    });
                case PlatformType.mtHotelMinaWebview:
                    // 美团酒店小程序
                    return monitorNavigateTo({
                        url: `/pages/poi/pages/index/index?poiId=${poiId}`,
                        _web: {
                            miniProgramNative: true
                        }
                    });
                case PlatformType.dpMinaWebview:
                    // 点评小程序
                    const url = `/packages/hotel/pages/poi/pages/index/index?shopId=${poiId}&shopUuid=${poiId}`;
                    return monitorNavigateTo({
                        url,
                        _web: {
                            miniProgramNative: true
                        }
                    });
                default:
                    if (options.wxLaunchPoiDetailUrlSchema) {
                        const encodedParams = encodeURIComponent(`poiId=${poiId}`);
                        const targetUrl = `${options.wxLaunchPoiDetailUrlSchema}&cq=${encodedParams}`;
                        return monitorNavigateTo({
                            url: targetUrl
                        });
                    }
                    else {
                        return monitorNavigateTo({
                            url: envokePoiDetailLink
                        });
                    }
            }
        }
        else {
            return monitorNavigateTo({
                url: envokePoiDetailLink
            });
        }
    }, [poiList]);
    return {
        loadRecommendPoi,
        requestStatus,
        recommendPoiData,
        poiList,
        browseRecommendedHotelPoi
    };
}
